'use client';

import DOMPurify from 'dompurify';

interface ContentDisplayProps {
  content: string;
  maxLength?: number;
}

export function ContentDisplay({ content, maxLength }: ContentDisplayProps) {
  // Sanitize content with DOMPurify - remove images and harmful content, keep only text
  const sanitizedContent = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'b',
      'i',
      'u',
      'a',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'span',
      'div',
      'blockquote',
      'code',
      'pre',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    FORBID_TAGS: [
      'img',
      'picture',
      'svg',
      'video',
      'audio',
      'iframe',
      'embed',
      'object',
      'script',
      'style',
      'link',
      'meta',
      'base',
      'form',
      'input',
      'button',
    ],
    FORBID_ATTR: ['style', 'onclick', 'onerror', 'onload', 'onmouseover', 'onfocus'],
    KEEP_CONTENT: true, // Keep text content even when tags are removed
  });

  // Truncate HTML content if maxLength is provided
  let displayContent = sanitizedContent;
  if (maxLength && sanitizedContent.length > maxLength) {
    // Basic HTML-aware truncation
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sanitizedContent;
    const textContent = tempDiv.textContent || tempDiv.innerText;
    if (textContent.length > maxLength) {
      displayContent = textContent.substring(0, maxLength) + '...';
    }
  }

  return <div dangerouslySetInnerHTML={{ __html: displayContent }} />;
}
